import React, { useEffect, useState } from 'react';
import { Portal } from '../Portal';
import { useDirection } from '../../../contexts/DirectionContext';

interface ToastProps {
  message: string;
  isVisible: boolean;
  onHide: () => void;
  duration?: number;
}

export const Toast: React.FC<ToastProps> = ({
  message,
  isVisible,
  onHide,
  duration = 2000,
}) => {
  const [isLeaving, setIsLeaving] = useState(false);
  const { isRTL } = useDirection();

  useEffect(() => {
    if (isVisible) {
      setIsLeaving(false);
      const timer = setTimeout(() => {
        setIsLeaving(true);
        setTimeout(onHide, 200);
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onHide]);

  if (!isVisible) return null;

  return (
    <Portal>
      <div 
        className={`
          fixed z-[9999] pointer-events-none
          /* Mobile: Center bottom positioning */
          left-1/2 -translate-x-1/2 bottom-8
          /* Desktop: Side positioning based on RTL/LTR */
          sm:bottom-12
          ${isRTL 
            ? 'sm:left-8 sm:right-auto sm:translate-x-0' 
            : 'sm:right-8 sm:left-auto sm:translate-x-0'
          }
          /* Ensure proper stacking */
          flex justify-center items-center
        `}
      >
        <div 
          className={`
            bg-black/90 text-white px-4 py-2 rounded-lg text-sm
            ${isLeaving ? 'animate-fade-out-down' : 'animate-fade-in-up'}
            shadow-lg
            max-w-[90vw] sm:max-w-md
            text-center
          `}
        >
          {message}
        </div>
      </div>
    </Portal>
  );
}; 